import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { SectionHead, FadeIn } from "./Reveal";

const FAQS = [
  {
    q: "Czy montaż jest możliwy pod fabryczne radio?",
    a: "Tak. Podłączamy subwoofer i wzmacniacz zarówno pod fabryczne, jak i niefabryczne radia — z pełnym zabezpieczeniem instalacji (bezpieczniki, okablowanie wysokiej jakości).",
  },
  {
    q: "Co daje wygłuszanie matami butylowymi?",
    a: "Redukcję szumów i drgań blach oraz lepszą akustykę i czystość dźwięku w kabinie. Wygłuszamy drzwi, bagażnik i podłogę.",
  },
  {
    q: "Jak wygląda skrzynia basowa na zamówienie?",
    a: "Projektujemy skrzynie Bass-Reflex i zamknięte, idealnie dobrane pod parametry głośnika i geometrię Twojego bagażnika.",
  },
  {
    q: "Pomożecie dobrać sprzęt do mojego budżetu?",
    a: "Tak, doradzamy w doborze wzmacniacza i głośników pod Twoje brzmienie i budżet — konkretnie i bez zaniżania parametrów.",
  },
  {
    q: "Ile kosztuje montaż?",
    a: "Wycena jest darmowa — wyślij formularz kontaktowy lub zadzwoń: +48 693 711 533.",
  },
  {
    q: "Gdzie i kiedy działa warsztat?",
    a: "Znajdujemy się w Opalenicy i pracujemy codziennie w godzinach 7:00–20:00.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 md:py-36" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-6 md:px-10">
        <SectionHead
          eyebrow="FAQ"
          title={
            <>
              Częste <span className="text-brand">pytania</span>
            </>
          }
        />
        <div className="mt-12">
          {FAQS.map((f, i) => (
            <FadeIn key={i} delay={i * 0.05}>
              <div className="border-t border-white/10 last:border-b">
                <button
                  data-testid={`faq-question-${i}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  aria-expanded={open === i}
                  className="flex w-full items-center justify-between gap-6 py-6 text-left"
                >
                  <span className="font-display text-lg md:text-xl font-medium uppercase tracking-wide text-white transition-colors duration-300 hover:text-brand">
                    {f.q}
                  </span>
                  <Plus
                    size={20}
                    className={`shrink-0 text-brand transition-transform duration-300 ${open === i ? "rotate-45" : ""}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-6 text-sm md:text-base leading-relaxed text-zinc-400">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
